class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    this.addEventListener('click', (event) => {
      if (event.target.closest('cart-remove-button, .quantity__button')) {
        setTimeout(() => window.ZvCartTab && window.ZvCartTab.refresh(), 600);
        setTimeout(() => window.ZvCartTab && window.ZvCartTab.refresh(), 1400);
      }
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.removeAttribute('role');
    cartLink.removeAttribute('aria-haspopup');
  }

  open(triggeredBy) {
    if (this.classList.contains('active')) return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add('overflow-hidden');

    this.querySelector('cart-drawer-items')?.dispatchViewEvent();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    if (window.ZvCartTab) window.ZvCartTab.refresh();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      const html = parsedState.sections && parsedState.sections[section.id];
      if (!html) return;
      const parsed = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(section.selector || '.shopify-section');
      if (!parsed) return;
      sectionElement.innerHTML = parsed.innerHTML;
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.setHeaderCartIconAccessibility();
      if (window.ZvCartTab) window.ZvCartTab.refresh();
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  // Dawn also re-renders the header cart icon here, by looking up an element id
  // that only exists in Dawn's own header. This store uses a custom header, so
  // that lookup returns nothing and the update throws. Only the drawer is
  // re-rendered; the counts are refreshed from the cart instead.
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/*
 * Zorevella storefront additions
 * This file loads on every page, so it also carries the store wide styling that
 * sits on top of the theme: the floating cart tab, the cart wording, and the
 * header search field.
 */
window.ZvCartTab = (function () {
  let tab = null;

  function build() {
    if (document.querySelector('.zv-cart-tab')) return;

    const style = document.createElement('style');
    style.textContent =
      // Floating cart tab
      '.zv-cart-tab{position:fixed;right:0;top:50%;z-index:1000;display:flex;align-items:center;gap:9px;' +
      'padding:15px 12px;border:0;cursor:pointer;background:#111;color:#fff;border-radius:2px 0 0 2px;' +
      'box-shadow:0 2px 14px rgba(0,0,0,.18);transform:translateY(-50%) translateX(110%);' +
      'transition:transform .35s cubic-bezier(.2,.7,.3,1),background .25s ease,padding-right .25s ease,' +
      'box-shadow .25s ease,opacity .2s ease}' +
      '.zv-cart-tab.is-visible{transform:translateY(-50%) translateX(0)}' +
      '.zv-cart-tab__icon{position:relative;display:flex;align-items:center;justify-content:center;' +
      'transition:transform .25s ease}' +
      '.zv-cart-tab svg{width:20px;height:20px;fill:none;stroke:currentColor;stroke-width:1.5;' +
      'stroke-linecap:round;stroke-linejoin:round;display:block}' +
      '.zv-cart-tab__count{position:absolute;top:-7px;right:-8px;min-width:16px;height:16px;padding:0 4px;' +
      'display:flex;align-items:center;justify-content:center;background:#fff;color:#111;border-radius:9px;' +
      'font-size:1rem;line-height:1;font-weight:700;letter-spacing:0}' +
      '.zv-cart-tab__label{max-width:0;overflow:hidden;white-space:nowrap;opacity:0;' +
      'font-size:1.1rem;letter-spacing:.14rem;text-transform:uppercase;font-weight:500;' +
      'transition:max-width .3s cubic-bezier(.2,.7,.3,1),opacity .25s ease}' +
      '.zv-cart-tab.is-visible:hover,.zv-cart-tab.is-visible:focus-visible{background:#000;' +
      'padding-right:16px;box-shadow:0 4px 22px rgba(0,0,0,.28)}' +
      '.zv-cart-tab.is-visible:hover .zv-cart-tab__label,' +
      '.zv-cart-tab.is-visible:focus-visible .zv-cart-tab__label{max-width:70px;opacity:1}' +
      '.zv-cart-tab.is-visible:hover .zv-cart-tab__icon{transform:translateX(-1px) scale(1.06)}' +
      'body.overflow-hidden .zv-cart-tab{transform:translateY(-50%) translateX(110%);opacity:0;' +
      'pointer-events:none}' +
      // Cart wording, drawer and cart page alike
      '.totals__total{position:relative;color:transparent!important}' +
      '.totals__total::after{content:"Total";position:absolute;left:0;top:0;' +
      'color:rgb(var(--color-foreground))}' +
      '.tax-note{display:none!important}' +
      '.cart-drawer__footer::after,.cart__footer::after{content:"Free shipping on every order. ' +
      'Taxes included.";display:block;margin-top:6px;font-family:var(--ai-font-accent,' +
      'var(--font-body-family));font-size:1.2rem;letter-spacing:.04rem;line-height:1.4;color:#1f6f43}' +
      // Header search field: a quiet grey bar, no box on focus, text centred in it
      '.ai-header__search-form{display:flex;align-items:center;min-height:54px;background:#f6f6f5;' +
      'border:0;border-bottom:1px solid #e6e6e3;border-radius:0;padding:0 16px;gap:12px;' +
      'margin-bottom:28px;box-shadow:none;' +
      'transition:background .22s ease,border-color .22s ease}' +
      '.ai-header__search-form:focus-within{background:#fff;border-bottom-color:#111}' +
      '.ai-header__search-input{flex:1 1 auto;height:auto;margin:0;padding:0;border:0;background:none;' +
      'font-family:var(--ai-font-accent,var(--font-body-family));font-size:1.2rem;letter-spacing:.18rem;' +
      'text-transform:uppercase;line-height:1.5;color:#111;appearance:none;-webkit-appearance:none}' +
      '.ai-header__search-input:focus,.ai-header__search-input:focus-visible{outline:0!important;' +
      'box-shadow:none!important;border:0!important}' +
      '.ai-header__search-input::placeholder{color:rgba(0,0,0,.38);opacity:1;' +
      'font-family:var(--ai-font-accent,var(--font-body-family));font-size:1.2rem;' +
      'letter-spacing:.18rem;text-transform:uppercase}' +
      '.ai-header__search-input::-webkit-search-cancel-button{-webkit-appearance:none;display:none}' +
      '.ai-header__search-form .ai-header__icon{align-self:center}' +
      '.ai-header__search-form .ai-header__icon svg{stroke-width:1.4;opacity:.45;' +
      'transition:opacity .22s ease}' +
      '.ai-header__search-form:focus-within .ai-header__icon svg{opacity:1}' +
      '.ai-header__search-heading{color:rgba(0,0,0,.42)}' +
      '@media screen and (max-width:749px){' +
      '.zv-cart-tab{top:auto;bottom:18px;transform:translateY(0) translateX(110%)}' +
      '.zv-cart-tab.is-visible{transform:translateY(0) translateX(0)}' +
      'body.overflow-hidden .zv-cart-tab{transform:translateY(0) translateX(110%)}' +
      '.zv-cart-tab__label{display:none}' +
      '.ai-header__search-form{min-height:48px}}';
    document.head.appendChild(style);

    tab = document.createElement('button');
    tab.type = 'button';
    tab.className = 'zv-cart-tab';
    tab.setAttribute('aria-haspopup', 'dialog');
    tab.setAttribute('aria-label', 'Open cart');
    tab.innerHTML =
      '<span class="zv-cart-tab__icon">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 7h12l-1 12H7z"></path>' +
      '<path d="M9 7a3 3 0 0 1 6 0"></path></svg>' +
      '<span class="zv-cart-tab__count">0</span></span>' +
      '<span class="zv-cart-tab__label">Cart</span>';

    tab.addEventListener('click', function () {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open(tab);
      } else {
        window.location = (window.routes && window.routes.cart_url) || '/cart';
      }
    });

    document.body.appendChild(tab);
    refresh();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    }
  }

  function syncHeader(count) {
    const links = document.querySelectorAll(
      '#cart-icon-bubble, a[href$="/cart"], a[href*="/cart?"], [data-cart-count], .cart-count'
    );

    links.forEach((link) => {
      const bubble = link.querySelector ? link.querySelector('.cart-count-bubble') : null;

      if (bubble) {
        if (count > 0) {
          const visible = bubble.querySelector('span[aria-hidden="true"]');
          if (visible) visible.textContent = count;
          const hidden = bubble.querySelector('.visually-hidden');
          if (hidden) hidden.textContent = count + (count === 1 ? ' item' : ' items');
        } else {
          bubble.remove();
        }
        return;
      }

      if (!link.querySelectorAll) return;
      link.querySelectorAll('span, div, em, i, small, b, strong').forEach((el) => {
        if (el.children.length) return;
        if (el.classList.contains('visually-hidden')) return;
        const text = el.textContent.trim();
        const looksLikeCounter =
          /^\d+$/.test(text) || /count|bubble|badge|qty|quantity/i.test(el.className || '');
        if (looksLikeCounter) el.textContent = count;
      });
    });
  }

  function setCount(count) {
    syncHeader(count);
    if (!tab) return;
    const label = tab.querySelector('.zv-cart-tab__count');
    if (label.textContent !== String(count)) label.textContent = count;
    tab.classList.toggle('is-visible', count > 0);
  }

  function refresh() {
    fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then((response) => response.json())
      .then((cart) => setCount(cart.item_count || 0))
      .catch(() => {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build, { once: true });
  } else {
    build();
  }

  return { refresh: refresh, build: build };
})();
